document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initGaleriaProducto();
  initVariantesProducto();
  initComparadores();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-delay') || 0;
          setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { io.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('[data-mt-countup]');
  if (!els.length) return;
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-mt-countup')) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        var duration = 1200;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var value = target * progress;
          el.textContent = (target % 1 === 0 ? Math.round(value) : value.toFixed(1)) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { io.observe(el); });
}

function initGaleriaProducto() {
  var wrap = document.querySelector('[data-mt-galeria]');
  if (!wrap) return;
  var main = wrap.querySelector('[data-mt-galeria-main]');
  var thumbs = wrap.querySelectorAll('[data-mt-galeria-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      if (!full || !main) return;
      main.src = full;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
}

function initComparadores() {
  var els = document.querySelectorAll('[data-mt-compare]');
  if (!els.length) return;
  els.forEach(function (el) {
    var range = el.querySelector('[data-mt-compare-range]');
    if (!range) return;
    function update() {
      el.style.setProperty('--mt-compare-pos', range.value + '%');
    }
    range.addEventListener('input', update);
    update();
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;
  var variantsScript = document.querySelector('[data-mt-variants-json]');
  if (!variantsScript) return;
  var variants;
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (e) {
    return;
  }
  var selects = form.querySelectorAll('[data-mt-option-select]');
  if (!selects.length) return;

  function findVariant() {
    var values = Array.prototype.map.call(selects, function (s) { return s.value; });
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === values[i]; });
    });
  }

  function updateUI() {
    var variant = findVariant();
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-mt-price]');
    var compareEl = document.querySelector('[data-mt-compare-price]');
    var submitBtn = form.querySelector('[data-mt-submit]');
    if (!variant) {
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = submitBtn.getAttribute('data-text-unavailable') || 'Unavailable'; }
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (variant.featured_image) {
      var mainImg = document.querySelector('[data-mt-galeria-main]');
      if (mainImg && mainImg.getAttribute('data-mt-no-swap') !== 'true' && mainImg.src !== variant.featured_image) {
        mainImg.src = variant.featured_image;
        var thumbs = document.querySelectorAll('[data-mt-galeria-thumb]');
        var matched = false;
        thumbs.forEach(function (t) {
          var isMatch = t.getAttribute('data-full') === variant.featured_image;
          t.classList.toggle('is-active', isMatch);
          if (isMatch) matched = true;
        });
        if (!matched) thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      }
    }
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (submitBtn) {
      if (variant.available) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.getAttribute('data-text-add') || 'Add to cart';
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.getAttribute('data-text-soldout') || 'Sold out';
      }
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  }

  selects.forEach(function (s) { s.addEventListener('change', updateUI); });
  updateUI();
}
